import { FC, useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { IOnlineCondolenceDetails } from '../types/resources/OnlineCondolenceDetails';
import { useApiService } from '../context/api/useApiContext';
import {useCandleContext} from '../context/candle/useCandleContext';
import OnlineCondolenceDetail from '../components/OnlineCondolence/OnlineCondolenceDetail';
import {usePostsContext} from '../context/posts/usePostsContext';
import SecurityTokenForm from '../components/SecurityTokenForm';
import {useTranslation} from 'react-i18next';
import { useSettingsContext } from '../context/settings/useSettingsContext';

const DetailPage: FC = () => {
    const {t} = useTranslation();
    const { pageUrl } = useParams();
    const { notFoundUrl } = useSettingsContext();
    const { apiService, companyInfoId } = useApiService();
    const { setCandleCount } = useCandleContext();
    const { setPostsCount } = usePostsContext();

    const [onlineCondolence, setOnlineCondolence] = useState<IOnlineCondolenceDetails>();
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [isPrivatePage, setIsPrivatePage] = useState<boolean>(false);
    const [isNotFound, setIsNotFound] = useState<boolean>(false);
    // const [securityToken, setSecurityToken] = useLocalStorage<string>(`${pageUrl}/securityToken`, '');
    const [securityToken, setSecurityToken] = useState<string>('');
    const [formSecurityToken, setFormSecurityToken] = useState('');

    const fetchOnlineCondolence = useCallback(async () => {
        setIsLoading(true);
        setHasError(false);

        try {
            // Fetching online condolence data from the API.
            const data = await apiService.getOnlineCondolenceByPageUrl(
                pageUrl as string,
                securityToken,
                companyInfoId
            );

            setOnlineCondolence(data);
            setCandleCount(data.numberOfCandles);
            setPostsCount(data.numberOfPosts);
            setIsPrivatePage(false);

        } catch (error: any) {
            // console.log(error);

            if (error.status && error.status === 400) {
                // Requires token.
                setIsPrivatePage(true);
            }
            if (error.status && error.status === 404) {
                // Not found, go to domain 404 page.
                if (notFoundUrl)
                {
                    window.location.href = notFoundUrl;
                }
                else
                {
                    // window.location.href = '/404';
                    setIsNotFound(true);
                }
            }

            setHasError(true);
        } finally {
            setIsLoading(false);
        }
    }, [apiService, pageUrl, securityToken, setCandleCount, setPostsCount]);

    useEffect(() => {
        fetchOnlineCondolence();
    }, [pageUrl, fetchOnlineCondolence]);

    const handleSecurityTokenSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsSubmitted(true);
        setSecurityToken(formSecurityToken);
    };

    return isPrivatePage
        ?
            <SecurityTokenForm
                securityToken={formSecurityToken}
                setSecurityToken={setFormSecurityToken}
                handleSubmit={handleSecurityTokenSubmit}
                hasError={(isSubmitted && hasError)}
            />
        : onlineCondolence
            ? <OnlineCondolenceDetail onlineCondolence={onlineCondolence}/>
            : isNotFound
                ? <div className={'cr-flex cr-center cr-m-xxl'}>{t('not-found')}</div>
                : null
    ;
}

export default DetailPage;
